
















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import { PostContents } from "@/request/zhuanbingshujuku";
import TemplateTransfer from "./template-transfer.vue";
import { forIn } from "lodash";
@Component({
  components: {
    TemplateTransfer,
  },
})
export default class CdrDetailCustom extends Vue {
  @Prop()
  private name: any;
  @Prop()
  private patient: any;
  @Prop()
  private templateInfo: any;
  @Prop()
  private zhenci: any;
  @Prop()
  private content: any;
  private cContent: any = {};
  private bitianMsg: any = [];
  private ifShowConfirm: boolean = false;
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private get templates() {
    return this.templateInfo["模板"];
  }
  @Watch("content", { immediate: true })
  private contentChange(content) {
    console.log("qqqqqsssss");
    console.log(content);
    this.$set(this, "cContent", content);
    this.saveMes();
  }
  /**
   * @description 生成id和标记必填提示信息
   */
  private saveMes() {
    if (!this.cContent.data) {
      return;
    }
    this.bitianMsg = [];
    this.cContent.data.forEach((ele, i) => {
      if (ele.is_required) {
        this.bitianMsg.push({
          required: false,
          tipMsg: ele.title + "为必填项！",
        });
      } else {
        this.bitianMsg.push({
          required: false,
          tipMsg: "",
        });
      }
    });
  }
  /**
   * @description 保存量表数据
   */
  private save() {
    this.saveMes();
    return new Promise((resolve, reject) => {
      for (let i = 0; i < this.cContent.data.length; i++) {
        if (this.cContent.data[i].is_required) {
          let weitian = true;
          if (this.cContent.data[i].type === "多选") {
            weitian = this.cContent.data[i].value.length === 0;
          } else if (
            this.cContent.data[i].type === "计分单选" ||
            this.cContent.data[i].type === "sf36计分单选"
          ) {
            weitian = !this.cContent.data[i].value.name;
          } else if (this.cContent.data[i].type === "计分条") {
            weitian = !this.cContent.data[i].value;
          }
          if (weitian) {
            // 没填的标红
            this.bitianMsg[i].required = true;
            // 弹提示哪个未填
            this.$message.warning(this.bitianMsg[i].tipMsg);
            // 滚动到没填的题目
            const parent = (document as any).getElementById("custom-templates");
            const child = (document as any).getElementById("liangbiao" + i);
            parent.scrollTop = child.offsetTop - parent.offsetTop;
            return;
          } else {
            this.bitianMsg[i].required = false;
          }
        }
      }
      const params: any = {
        patient_id: this.patient.patient_id,
        project_id: this.templateInfo.project_id,
        group_id: this.templateInfo.group_id,
        template_id: this.templateInfo.template_id,
        zhenci_id: this.zhenci.zhenci_id,
        content_id: this.cContent.content_id,
        data: this.cContent.data,
        create_time: this.cContent["create_time"],
      };
      PostContents(this, params).then((data: any) => {
        this.cContent = data;
        this.$message.success("保存成功");
        this.$store.commit("updateIfCompose", false);
        this.$emit("refresh");
        resolve();
      });
    });
  }
}
